<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2" color="grey lighten-5">
        <v-card class="my-3">
          <v-card-title>機械一覧
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search" color="indigo"
              single-line
              hide-details
              class="py-2 mx-2"
            ></v-text-field>
            <v-btn width="120" class="mx-2" to='/KkiMstr/KkiMstrSnkTurk' color="indigo" dark>新規登録</v-btn>
            <v-btn width="120" color="indigo" dark @click="downloadCSV">ダウンロード</v-btn>
          </v-card-title>
          <v-data-table
            no-data-text="データがありません"
            no-results-text="検索結果が見つかりません"
            :loading="loading"
            loading-text="読み込み中です"
            :headers="headers"
            :items="listItems"
            :search="search"
            :height="listHeight"
            :footer-props="{
              'items-per-page-options': [10,30,50,-1]
            }"
            fixed-header
          >
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs" icon color="indigo" @click="showDetail(item.id)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>詳細</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../../modules/MstrHedr'
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios.js'

export default {
  components: {
    MstrHedr
  },
  data () {
    return {
      windowSize: {
        x: 0,
        y: 0
      },
      listHeight: 600,
      userInfo: false,
      listItems: [],
      rowSelected: 50,
      loading: true,
      totalList: 0,
      nowList: 0,
      searchWord: '',
      search: '',
      headers: [
        { text: '', value: 'actions', sortable: false },
        {
          text: '機械名',
          align: 'start',
          value: 'kki_nm'
        },
        {text: '機械名略称', value: 'kki_nm_ryksh'},
        {text: '機種名', value: 'ksh_nm'},
        {text: '設置場所', value: 'set_bsh'},
        {text: '納入日', value: 'nuny_dt'}
      ]
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      myAxios.get('/api/common/session_manager', {type: 'kngn_check', url: this.$route.path}).then(res => {
        const kngnStatus = res.data.result.status
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result && kngnStatus)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
          this.$store.dispatch('appSetting/fLogin')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // インスタンス生成時にセッションにある検索キーワードを破棄する
          myAxios.delete('api/kki_mstr/kikai_master_kanri').then(res => {
            //  機械情報一覧をDBから持ってくる
            this.getMemberList()
          })
        }
      })
    })
  },
  watch: {
  },
  // 更新時に毎回呼び出される
  mounted () {
    this.onResize()
    this.changeListSize()
  },
  methods: {
    // 画面サイズ取得
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    // 一覧表示サイズを変更
    changeListSize () {
      this.listHeight = this.windowSize.y * 0.7
    },
    // 機械一覧を取得する
    getMemberList () {
      myAxios.get('api/kki_mstr/kikai_master_kanri').then(res => {
        // 0が帰ってきたらリストアイテムは空にする
        if (res.data === 0) {
          this.listItems = []
          this.loading = false
        } else {
          this.totalList = res.data[0]
          this.listItems = res.data[1]
          this.loading = false
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        console.log(err)
        this.listItems = []
        this.loading = false
      })
    },
    // 機械一覧をCSV形式でDLする
    downloadCSV () {
      // axiosでダウンロードデータを取得する
      myAxios.get('api/kki_mstr/kikai_master_download', { search: this.search }).then(res => {
        let csv = '\ufeff' + '機械名,機械名略称,機種名,設置場所,納入日\n'
        // 取得したレコードを行ごとに整形する
        res.data.forEach(el => {
          let line = el['kki_nm'] + ',' + el['kki_nm_ryksh'] + ',' + el['ksh_nm'] + ',' + el['set_bsh'] + ',' + el['nuny_dt'] + '\n'
          csv += line
        })
        let blob = new Blob([csv], { type: 'text/csv' })
        let link = document.createElement('a')
        const date = new Date()
        link.href = window.URL.createObjectURL(blob)
        // 月を0埋めする
        var mon = String(date.getMonth() + 1)
        if (mon.length === 1) { mon = '0' + mon }
        var day = String(date.getDate())
        if (day.length === 1) { day = '0' + day }
        link.download = 'list_machine_' + date.getFullYear() + mon + day + '.csv'
        link.click()
      })
    },
    showDetail (id) {
      this.$store.dispatch('appSetting/selectItem', id)
      this.$router.push({path: '/KkiMstr/KkiMstrJuhuShusi'})
    }
  },
  computed: {
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/templates/KkiMstr/KkiMstrKnr.vue